// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"wrapper__2HFnK","top":"top__2LB40","title":"title__2eLgg","titleLarge":"titleLarge__3dvlb title__2eLgg","lolk":"lolk__3e6xY","unit":"unit__132Ho","btnGram":"btnGram__1a6MN unit__132Ho","btnGramText":"btnGramText__jAdT6","label":"label__2OZYL"};


//////////////////
// WEBPACK FOOTER
// ./components/wrapper/style.css
// module id = t0U0
// module chunks = 0